import { observable, action} from "mobx";
import {post} from "../services/ajax.service";

class NoCopayStore {
  @observable claims = [];
  @observable drug_fills = [];
  @observable five_drugs = [];
  @observable no_co_pay_cost = 0;
  @observable no_co_pay_drug_count = 0;
  @observable url ="/api/v1/insightactions/nocopay";

  

  @action getNoCoPayDrugCount = async data => {
    this.no_co_pay_drug_count = 0;

    
  try {
    let response = await post(
      `${this.url}/getNoCoPayDrugCount`,
      data
    );

    this.no_co_pay_drug_count = response.data.length
  } catch (err) {
    console.log(err);
  }
};
  @action getNoCoPayCost = async data => {
    this.no_co_pay_cost = 0;

    
  try {
    let response = await post(
      `${this.url}/getNoCoPayCost`,
      data
    );

    this.no_co_pay_cost = response.data[0].claim_cost
  } catch (err) {
    console.log(err);
  }
};
  @action getNoCopayClaimsCost = async data => {
      this.claims = [];
      this.drug_fills = [];
      
    try {
      let response = await post(
        `${this.url}/getNoCopayClaimsCost`,
        data
      );

      this.claims = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getNoCopayClaimCount = async data => {
    this.claims = [];
      this.drug_fills = [];
  try {
    let response = await post(
      `${this.url}/getNoCopayClaimCount`,
      data
    );

    this.claims = response.data;
  } catch (err) {
    console.log(err);
  }
};

@action getIndividualDrugFill = async data => {
    this.drug_fills = [];
  try {
    let response = await post(
      `${this.url}/getIndividualDrugFill`,
      data
    );

    this.drug_fills = response.data;
  } catch (err) {
    console.log(err);
  }
};

@action getTopFiveNoCopayDrugs = async data => {
    this.five_drugs = [];
  try {
    let response = await post(
      `${this.url}/getTopFiveNoCopayDrugs`,
      data
    );

    this.five_drugs = response.data;
  } catch (err) {
    console.log(err);
  }
};


  
}

export default NoCopayStore;
